export const GENERIC_TRANSLATION_ERROR = 'An error occurred while translating the report. Please try again later.'
